import { Component, OnInit } from '@angular/core';
import { HashKeyServices } from '../servicios/app.hashkey.services';
import { AppUtilService } from '../servicios/app.util.service';
import { AtributosService } from '../servicios/atributos.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  
  fecha:any;
  usuario:any;
  unidad:any;
  dpto:any;
  licencia:any;
  constructor(
    private util:AppUtilService,
    private atrb:AtributosService,
    private hashkey:HashKeyServices
  ) { }

 async ngOnInit(){
    this.fecha = await this.atrb.FECHA.yyyy;
    /* this.usuario = await this.hashkey.decrypt(this.atrb.NOMBRE_USUARIO.nombre) +' '+ await this.hashkey.decrypt(this.atrb.APELLIDO_USUARIO.apellido);
    this.unidad = await this.hashkey.decrypt(this.atrb.UNIDAD_USUARIO.unidad);
    this.dpto = await this.hashkey.decrypt(this.atrb.DPTO_USUARIO.dpto);
    this.licencia = await this.hashkey.decrypt(this.atrb.MOD_USUARIO.mod_usuario);  */
  }
}
